var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgA3Icon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.4,
    height: 20,
    viewBox: "0 0 27.4 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "A3-Icon",
    transform: "translate(13.7 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "A3-Icon-2",
    "data-name": "A3-Icon",
    transform: "translate(-13.7 -10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1127",
    "data-name": "Group 1127"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1126",
    "data-name": "Group 1126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M91.81,0l-.688,1.867A22.5,22.5,0,0,1,96.978,0Z",
    transform: "translate(-80.997)",
    fill: "#004987"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M61.188,169.405l.416-1.324A10.4,10.4,0,0,0,58,169.405Z",
    transform: "translate(-51.553 -149.405)",
    fill: "#004987"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M21.859,114.724c1.76.1,3.608.24,5.541.444a45.956,45.956,0,0,0-27.4,1,47.235,47.235,0,0,1,5.552-.965l-2.107,5.721H5.684A9.751,9.751,0,0,1,10.3,118.8l.229-.73h6.359l.841,2.857h2.1a7.916,7.916,0,0,1,3.689-1.635Z",
    transform: "translate(0 -100.927)",
    fill: "#004987"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M62.422,43.062h.056l1.532,5.263a48.86,48.86,0,0,1,5.937.4l-2.668-7.327a20.439,20.439,0,0,1,4.572.281,15.27,15.27,0,0,0-4.745-.757l0,0-.154,0c-.465,0-.955.017-1.462.061A22.549,22.549,0,0,0,57,42.96l-2.308,6.264a44.6,44.6,0,0,1,6.053-.8Z",
    transform: "translate(-48.612 -36.367)",
    fill: "#004987"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M185.108,169.508h3.55l-.477-1.311A9.308,9.308,0,0,0,185.108,169.508Z",
    transform: "translate(-164.54 -149.508)",
    fill: "#004987"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M84.63,6.937h.888a.5.5,0,0,0,.126.387.474.474,0,0,0,.388.145c.267,0,.435-.1.435-.364,0-.285-.22-.336-.435-.336a1.558,1.558,0,0,0-.271.024V6.157c.07,0,.145.018.271.018.2,0,.444-.042.444-.295,0-.205-.233-.285-.425-.285-.253,0-.458.135-.449.406h-.878a1.029,1.029,0,0,1,.406-.85,1.608,1.608,0,0,1,.949-.271c.944,0,1.257.561,1.257.836,0,.683-.43.683-.43.7v.009a.689.689,0,0,1,.533.762.943.943,0,0,1-.267.643c.608.006,1.164.034,1.653.074L87.448,4.121A25.681,25.681,0,0,0,80.4,5.982l-1.152,3.13A22.326,22.326,0,0,1,85,7.9,1.126,1.126,0,0,1,84.63,6.937Z",
    transform: "translate(-70.446 -3.663)",
    fill: "#004987"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgA3Icon);
export default __webpack_public_path__ + "static/media/A3-Icon.430e6b40737d536d255e427178e66454.svg";
export { ForwardRef as ReactComponent };